/**
 * ProcessoDetailsModal Component (Simplified)
 * Story: 11.5 - Processos Atribuídos
 */
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useProcessoDetails } from "@/hooks/useProcessosParceiro";
import { Loader2 } from "lucide-react";

interface ProcessoDetailsModalProps {
  processoId: string;
  isOpen: boolean;
  onClose: () => void;
}

const ProcessoDetailsModal: React.FC<ProcessoDetailsModalProps> = ({
  processoId,
  isOpen,
  onClose,
}) => {
  const { data: processo, isLoading } = useProcessoDetails(processoId);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {isLoading ? "Carregando..." : processo?.numero || "Detalhes do Processo"}
          </DialogTitle>
        </DialogHeader>

        {isLoading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="w-8 h-8 animate-spin" />
          </div>
        ) : processo ? (
          <Tabs defaultValue="resumo" className="w-full">
            <TabsList className="grid w-full grid-cols-4">
              <TabsTrigger value="resumo">Resumo</TabsTrigger>
              <TabsTrigger value="timeline">Timeline</TabsTrigger>
              <TabsTrigger value="documentos">Documentos</TabsTrigger>
              <TabsTrigger value="pagamentos">Pagamentos</TabsTrigger>
            </TabsList>

            <TabsContent value="resumo" className="space-y-4">
              <div>
                <h3 className="font-semibold mb-2">Título</h3>
                <p>{processo.titulo}</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Descrição</h3>
                <p>{processo.descricao || "Sem descrição"}</p>
              </div>
            </TabsContent>

            <TabsContent value="timeline">
              <p>Timeline em desenvolvimento...</p>
            </TabsContent>

            <TabsContent value="documentos">
              <p>{processo.total_documentos} documento(s)</p>
            </TabsContent>

            <TabsContent value="pagamentos">
              <p>{processo.total_pagamentos} pagamento(s)</p>
            </TabsContent>
          </Tabs>
        ) : (
          <p>Processo não encontrado</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ProcessoDetailsModal;
